import { createAction } from 'redux-act';

import Notification from '../../../models/interfaces/Notification';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export const fetchNotifications = createAction<FetchPayload>('FETCH_NOTIFICATIONS');

export interface NotificationsFetchedPayload extends TimestampPayload {
  notifications: Notification[];
}
export const notificationsFetched = createAction<NotificationsFetchedPayload>('NOTIFICATIONS_FETCHED');

export type NotificationsFetchFailedPayload = TimestampPayload;
const actionName = 'NOTIFICATIONS_FETCH_FAILED';
export const notificationsFetchFailed = createAction<NotificationsFetchFailedPayload>(actionName);
export type NotificationsFetchResponsePayload = NotificationsFetchedPayload | NotificationsFetchFailedPayload;
